import Marionette from 'backbone.marionette';

/**
 * https://www.joezimjs.com/javascript/using-marionette-to-display-modal-views/
 * Usage:
 * var modal = new ModalRegion({el:'#modal'});
 * var view = new SomeView();
 * modal.show(view);
 */

export default Marionette.Region.extend( {
   constructor: function () {
      Marionette.Region.prototype.constructor.apply( this, arguments );

      this.$el.on( 'hidden.bs.modal', {region: this}, function ( event ) {
         event.data.region.empty();// force template to get rerendered if same view is opened again.
      } );
      this.$el.on( 'shown.bs.modal', {region: this}, function ( event ) {
         if( typeof event.data.region.currentView.onModalShown === "function" ) {
            event.data.region.currentView.onModalShown( event );
         }
      } );
   },

   onShow: function ( region, view, options = {backdrop: true, keyboard: true} ) {
      view.$el.attr( {class: 'modal-dialog', role: 'document'} )
      if( this.$el.data( 'bs.modal' ) ) {
         Object.assign( this.$el.data( 'bs.modal' )._config, options );
      }
      this.$el.modal( options );
   },
   onEmpty: function () {
      this.$el.modal( 'hide' );
   }
} );